import './ChannelIcon.css';

export function ChannelIcon({ icon }: { icon?: string }) {
    return <>{icon && <img src={icon} className='channel-icon' alt='Channel Icon' />}</>;
}
